import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import axios from '@/app/axios'
import debounce from 'lodash/debounce'
import { Debouceable } from '@/app/types/debouncable'
import NodeEntity from '@/common/models/node-entitiy'
import Responses from '@/app/utils/responses'
import cloneDeep from 'lodash/cloneDeep'
import Matches from '@/diagrams/models/matches'
import Match from '@/diagrams/models/match'

@Component
export default class NameInput extends Vue {

  @Prop({ required: true })
  private container!: NodeEntity

  @Prop({ required: true })
  private className!: NodeClassName

  @Prop({ default: null })
  private parentId!: null | string

  @Prop({ default: false })
  private editMode!: boolean

  @Prop({ required: true })
  private entityLabel!: string

  @Prop({ required: true })
  private entitiesLabel!: string

  @Prop({ required: true })
  private url!: string

  @Prop({ default: false })
  private archived!: boolean

  private loading: boolean = false
  private selectMode: boolean = !this.editMode
  private model = cloneDeep(this.container)
  private search: string = ''
  private items: any[] = []
  private selection: Match = new Match()
  private debouncedLoad: Debouceable = null

  @Watch('editMode')
  private editModeChanged(val: boolean, old: boolean) {
    this.selectMode = !val
  }

  @Watch('container', { deep: true })
  private containerChanged(val: NodeEntity, old: NodeEntity) {
    this.model = cloneDeep(val)
  }

  @Watch('search')
  private async searchUpdated(val: string, old: string) {
    if (val !== old) {
      await this.findMatchesDebounced(val)
    }
  }

  private onInput(name: string) {
    if (name.length >= 3) {
      this.$emit('input', { name })
    }
  }

  private async onFocus() {
    await this.findMatches('')
  }

  private onChange(selection: Match) {
    if (selection.name.length >= 3) {
      this.model.name = selection.name
      this.$emit('input', selection)
      this.selection = new Match()
      this.selectMode = false
    }
  }

  private async findMatchesDebounced(text: string = '') {
    if (this.debouncedLoad) {
      this.debouncedLoad.cancel()
    }
    this.debouncedLoad = debounce(async () => this.findMatches(text), 500)
    this.debouncedLoad()
  }

  private async findMatches(text: string = '') {
    this.loading = true
    const matches = await this.fetchMatches(text)
    this.items = []
    if (matches != null) {
      this.items.push({ header: 'Vervollständigung' })
      this.items.push(...matches.matches)
      this.items.push({ header: `Häufig verwendete ${this.entitiesLabel}` })
      this.items.push(...matches.popular)
    }
    this.loading = false
  }

  private async fetchMatches(text: string = '') {
    let url = `${this.url}?type=${this.className}`
    if (this.parentId) {
      url += `&parentId=${this.parentId}`
    }
    if (text) {
      url += `&text=${text}`
    }
    const res = await axios.get<Matches>(url)

    return Responses.obj(res)
  }

  private highlight(v: string) {
    if (v) {
      const regex = new RegExp(`(${this.search})`, 'ig')
      return v.replace(regex, '<strong>$1</strong>')
    }
    return ''
  }

  // private async mounted() {
  //   await this.findMatches('')
  // }
}
